var _line, _line2, _line3, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.333252,
    y1: 4.59338,
    x2: 31.7499,
    y2: 4.59338,
    stroke: "#3F6BAB"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.333252,
    y1: 16.0177,
    x2: 31.7499,
    y2: 16.0177,
    stroke: "#3F6BAB"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.333252,
    y1: 27.4419,
    x2: 31.7499,
    y2: 27.4419,
    stroke: "#3F6BAB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7537,
    cy: 4.61743,
    r: 3.78409,
    fill: "white",
    stroke: "#3F6BAB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7538,
    cy: 27.4659,
    r: 3.78409,
    fill: "white",
    stroke: "#3F6BAB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2816,
    cy: 16.0416,
    r: 3.78409,
    fill: "white",
    stroke: "#3F6BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullSearch);
export default __webpack_public_path__ + "static/media/full-search.c57a9b9860fa16e5eb40b70f67208d83.svg";
export { ForwardRef as ReactComponent };